export default __webpack_public_path__ + "static/media/eyitayo-ogunmola-v2Podcast.9a36acbf.png";